import { FC } from 'react'
import { ContentContainer } from '../../../../components/custom_components/ContentContainer'
import { CurrencyFromContractProvider } from '../../../../context/currency-context'
import { useMeetingWithCareerPathEvaluation } from '../../../../graphql/meeting/hooks/useMeetingWithCareerPathEvaluation'
import { useCollapse } from '../../../../routes/collapse-context'
import { MeetingType } from '../../../../types'
import OtherMeetingView from '../../../otherMeetings/OtherMeetingView'
import { MeetingViewProps } from '../shared/appraisal-types'
import AppraisalMeetingView from './AppraisalMeetingView'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'
import { useAuth } from '../../../../context/auth-context'

export const AppraisalMeetingContainer: FC<MeetingViewProps> = ({ match }) => {
  const meetingId = match.params.id
  const collapsed = useCollapse()
  const { user } = useAuth()

  const { data, error, loading } = useMeetingWithCareerPathEvaluation(meetingId)

  if (
    loading ||
    error ||
    !data ||
    !data.meeting ||
    !data.meeting.reviewer ||
    data.meeting.reviewer.id !== user.employeeId ||
    !data.meeting.managerPrepared
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={!data || !data.meeting || !data.meeting.reviewer}
          error={error}
          showSpinner
          isPermissionDenied={
            !error &&
            !!data &&
            !!data.meeting &&
            !!data.meeting.reviewer &&
            (!data.meeting.managerPrepared || (!!data.meeting.reviewer && data.meeting.reviewer.id !== user.employeeId))
          }
        />
      </ContentContainer>
    )
  } else {
    const meetingType = data.meeting.type

    return (
      <CurrencyFromContractProvider employeeId={data.meeting.employee.id}>
        <div data-e2e-meeting-view-container>
          {meetingType === MeetingType.Appraisal || meetingType === MeetingType.AppraisalUpdate ? (
            <AppraisalMeetingView meeting={data.meeting} />
          ) : (
            <OtherMeetingView meeting={data.meeting} />
          )}
        </div>
      </CurrencyFromContractProvider>
    )
  }
}
